import { createTheme, useMediaQuery } from "@mui/material";

declare module "@mui/material/styles" {
  interface BreakpointOverrides {
    xs: false; // removes the `xs` breakpoint
    sm: false;
    md: false;
    lg: false;
    xl: false;
    mobile: true; // adds the `mobile` breakpoint
    tablet: true;
    laptop: true;
    desktop: true;
  }
}

export const useScreenSize = () => {
  const theme = createTheme({
    breakpoints: {
      values: {
        mobile: 0,
        tablet: 769,
        laptop: 900,
        desktop: 1080
      }
    }
  });
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("tablet"));
  const isMediumScreen = useMediaQuery(
    theme.breakpoints.between("tablet", "desktop")
  );
  const isLargeScreen = useMediaQuery(theme.breakpoints.up("desktop"));
  return { isSmallScreen, isMediumScreen, isLargeScreen, theme };
};
